import type { CourseStructureItem } from '@vedalib/editor/lib/elements'
import React from 'react'

import { useCourseSidebarData } from 'components/Editor/cource/controls/CourseSidebar/context/selectors'
import { getIconData } from 'components/Editor/cource/controls/CourseSidebar/utils'
import Highlighter from 'components/uiKit/Highlighter'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { useProjectT } from 'services/ProjectLabels'
import { scrollProps } from 'services/Scroll/ScrollService'
import { testPropsEl } from 'utils/test/qaData'

import * as s from './StructureItemCourse.module.scss'

interface IItemsProps {
  item: CourseStructureItem
  searchValue?: string
  nestedOffset?: number
  disabled?: boolean
}

const StructureItemCourse: React.FC<IItemsProps> = ({
  item,
  searchValue,
  nestedOffset,
  disabled,
}) => {
  const { styles, font } = useCourseSidebarData()
  const pt = useProjectT()
  const { showIcon, IconImage, styleFontSection, icon, sectionNameStyles, iconStyles } =
    getIconData({
      type: item.type,
      styles,
      font,
      nestedOffset,
      disabled,
    })

  return (
    <>
      {showIcon && (
        <div className={IconImage ? s.iconImage : s.itemIcon} style={iconStyles}>
          {!IconImage && <Icon name={icon} size={KitSize.S} />}
        </div>
      )}
      <div
        {...testPropsEl('sectionItem', { name: item.name }, { id: item.id })}
        {...scrollProps(item.id)}
        className={s.item}
        style={sectionNameStyles}
      >
        <div className={s.itemContent}>
          <div style={styleFontSection}>
            {item.name ? (
              <Highlighter search={searchValue} text={item.name} wordBreak='break-word' />
            ) : (
              pt('courseStructure.chapterName')
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default StructureItemCourse
